<div class="toggle-menu" (click)="toggleMenu()">
  <div class="menu">
    <span class="line" [ngClass]="{ 'active1-menu': showMenu && activateAnimation }"></span>
    <span class="line" [ngClass]="{ 'active2-menu': showMenu && activateAnimation }"></span>
    <span class="line" [ngClass]="{ 'active3-menu': showMenu && activateAnimation }"></span>
  </div>
</div>